import React from "react";
import { BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { AiFillGithub } from "react-icons/ai";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/soulden1202" target="_blank">
        <AiFillGithub />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/huy-ngo-1b2190196/" target="_blank">
        <BsLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
